// extracted by mini-css-extract-plugin
export default {"Button":"styles_Button__jetxD","Heading":"styles_Heading__rdUSq","SubHeading":"styles_SubHeading__gmFnM"};